export default __webpack_public_path__ + "static/media/maintenance.34edcdc3.webp";